export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";